module.exports = __webpack_public_path__ + "static/media/icon_banner.868d789a.png";